export default {
      id: "icon-arrow-left-no-shaft-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-arrow-left-no-shaft",
      toString: function () {
        return this.url;
      }
    }